import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports ----

import * as logbookActions from '~/store/logbook/actions';
import { EMPLOYEES_HIRE } from '~/store/employees/actionTypes';
import { ADS_RENT } from '~/store/ads/actionTypes';
import { TRADESHOW_HIRE } from '~/store/tradeshows/actionTypes';
// ---- internal imports ----

const fetchUpdatedLogbookEpic = (action$) => action$.pipe(
	ofType(
		EMPLOYEES_HIRE,
		ADS_RENT,
		TRADESHOW_HIRE
	),
	// action is passed automatically to fetchUpdatedLogbook
	//	wrapped with a function to avoid sending action aas props
	map(() => logbookActions.fetchUpdatedLogbook())
);

export default fetchUpdatedLogbookEpic;
